import { render, staticRenderFns } from "./Rental.vue?vue&type=template&id=552e42d3&scoped=true&"
import script from "./Rental.vue?vue&type=script&lang=js&"
export * from "./Rental.vue?vue&type=script&lang=js&"
import style0 from "./Rental.vue?vue&type=style&index=0&id=552e42d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e42d3",
  null
  
)

export default component.exports